import { useLocation, useNavigate } from "react-router-dom";
import { SCREENS } from "utils/constants";
import CanvasRunner from "../../Runtime/CanvasRunner";
import { shouldOpenBrokerSubscription } from "../../Runtime/quotedSubscription";
import withEnv from "./withEnv";

const Step = ({ project, processId, onBack }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  // Canvas nodes decide when to open (openSubscriptionOnEnter / goToSubscription).
  // Do not gate that on a hardcoded process id: an imported copy must still
  // be able to open the quoted subscription. Guest web stays on the project:
  // /broker/subscriptions is not a guest route and would dump to login.
  const onSubscriptionReady = (subscriptionId) => {
    if (!shouldOpenBrokerSubscription(pathname)) return;
    navigate(
      `${SCREENS.PRIVATE.BROKER.SUBSCRIPTIONS.DETAIL.path}/${subscriptionId}`,
    );
  };

  return (
    <CanvasRunner
      project={project}
      process={{ id: processId }}
      onBack={onBack}
      onSubscriptionReady={onSubscriptionReady}
    />
  );
};

export default withEnv(Step);
